import { ThemeProvider } from "@repo/core/providers/ThemeProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppProvidersProps } from "./types";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { BottomSheetProvider } from "@repo/core/providers/BottomSheetProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <SafeAreaProvider>
      <ThemeProvider>
        <BottomSheetProvider>
          <QueryClientProvider client={queryClient}>
            {children}
          </QueryClientProvider>
        </BottomSheetProvider>
      </ThemeProvider>
    </SafeAreaProvider>
  );
};
